import { FormsLayout, NotificationsProvider } from '@src/components';
import { CoreProvider } from '@src/core';
import { FC } from 'react';
import { AppProvider, LocalStorageProvider } from '~/contexts';
import { FormsTheme } from '~/themes';
import { FormsRouter } from './forms.router';

const FormsIndex: FC = () => (
  <FormsTheme>
    <LocalStorageProvider>
      <NotificationsProvider>
        <CoreProvider>
          <AppProvider>
            <FormsLayout>
              <FormsRouter />
            </FormsLayout>
          </AppProvider>
        </CoreProvider>
      </NotificationsProvider>
    </LocalStorageProvider>
  </FormsTheme>
);

export default FormsIndex;
